/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import LegalDocumentPage from "../components/LegalDocumentPage";

const sections = [
  {
    title: "End User License Agreement",
    body:
      "This End User License Agreement (“EULA”) applies to software, browser extensions, mobile apps, and other downloadable products published by Volta Software. By installing or using licensed software, you agree to this EULA.",
  },
  {
    title: "License grant",
    body:
      "Volta Software grants you a limited, non-exclusive, non-transferable, revocable license to install and use the software for personal or internal business purposes, subject to this agreement and any product-specific terms.",
  },
  {
    title: "Restrictions",
    body:
      "You may not copy, modify, reverse engineer, decompile, sublicense, sell, or distribute the software except as expressly permitted by law or by Volta Software in writing. You may not remove proprietary notices or use the software to build a competing product.",
  },
  {
    title: "Ownership",
    body:
      "The software is licensed, not sold. Volta Software and its licensors retain all rights, title, and interest in the software and related materials.",
  },
  {
    title: "Updates",
    body:
      "We may provide updates, patches, or new versions at our discretion. Some updates may be required for continued use. Updated software remains subject to this EULA unless accompanied by new terms.",
  },
  {
    title: "Termination",
    body:
      "This license ends if you violate the EULA or if we discontinue the product. Upon termination, you must stop using and uninstall the software.",
  },
  {
    title: "Disclaimer of warranties",
    body:
      "The software is provided “as is” without warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement, to the extent permitted by law.",
  },
  {
    title: "Limitation of liability",
    body:
      "To the maximum extent permitted by law, Volta Software is not liable for damages arising from use or inability to use the software, including lost data or profits, even if advised of the possibility of such damages.",
  },
  {
    title: "Contact",
    body: "Licensing questions can be sent to admin@voltasoftware.net.",
  },
];

function LicenseVoltaSoftware() {
  return <LegalDocumentPage title="Licenses (EULA)" sections={sections} />;
}

export default LicenseVoltaSoftware;
